export class NoCurrentAccountError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'NoCurrentAccountError'
  }
}
